export const Minus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="M232-444v-72h496v72H232Z" />
  </svg>
);
